import classNames from 'classnames';
import { ReactNode } from 'react';
import { PW_MARKER_SELECTOR } from 'utilities/consts/variable-types.js';
import { PopulateMarkerArr } from '../additional-content/marker-content.js';
import { MarkerContentItem } from '../additional-content/utils.js';

interface IMarkerContent {
  label?: string;
  icons?: ReactNode[];
  markerContent: MarkerContentItem[];
}

export const HTMLMarkerCore = ({ label, icons, markerContent }: IMarkerContent) => {
  /** Dangerously set inner here to display special chars without needing to escape e.g. macrons */
  return (
    <div data-component="html-marker-core" className="u-flex" data-testid={PW_MARKER_SELECTOR}>
      {!!icons?.length && <div className="Map-tooltip-content-icons">{icons}</div>}
      <div className="Map-tooltip-content-text">
        <span className={classNames({ 'u-pR-xs u-bR-1': markerContent.length > 0 })}>{label}</span>
        <PopulateMarkerArr contentArr={markerContent} />
      </div>
    </div>
  );
};
